<template>
    <v-dialog
        v-model="dialogLogin"
        width="500"
        persistent
    >
        <v-card>
            <v-col cols="12" class="text-center pt-3">
                <img class="mt-3" alt="Login" src="../../../../assets/grupo-inno.jpg" style="width: 250px;">
            </v-col>
            <div v-if="typeAccess=='login'">
                <v-card-text>
                    <v-col cols="12" class="text-center"><b>{{text}}</b></v-col>
                    <v-form ref="form_login">
                        <v-text-field
                            v-model="user"
                            label="Usuario"
                            prepend-icon="mdi-account"
                            type="text"
                            :rules=requiredRule
                        ></v-text-field>
                        <v-text-field
                            v-model="password"
                            label="Contraseña"
                            prepend-icon="mdi-lock"
                            :type="show ? 'text' : 'password'"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show = !show"
                            :rules=requiredRule
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-spacer></v-spacer>
                <v-col  class="text-center">
                    <v-btn 
                        color="primary" 
                        :loading=loadingBtn
                        class="px-5 text-center mx-2"
                        @click="loginClient"
                    >
                        <v-icon>mdi-login-variant</v-icon> INGRESAR
                    </v-btn>
                    <v-btn class="mx-2"
                        @click="$emit('close')"
                    >
                        <v-icon>mdi-cancel</v-icon> CERRAR
                    </v-btn>
                </v-col>
                <v-col>
                    <v-row>
                        <v-col md="6">
                            <v-col class="text-center">
                                <v-btn 
                                    small 
                                    text 
                                    color="primary"
                                    link
                                    @click="typeAccess='create-account'"
                                >
                                    <b><v-icon>mdi-account-key</v-icon> Crear una cuenta</b>
                                </v-btn>
                            </v-col>
                        </v-col>
                        <v-col md="6">
                            <v-col class="text-center">
                                <v-btn 
                                    small 
                                    text 
                                    color="primary"
                                    link
                                    @click="typeAccess ='restart-pass'"
                                >
                                <b><v-icon>mdi-comment-question-outline</v-icon> Olvide mi contraseña</b>
                                </v-btn>
                            </v-col>
                        </v-col>
                    </v-row>
                </v-col>
            </div>
            <div v-if="typeAccess=='create-account'" >
                <v-card-text class="py-0">
                <v-col cols="12" class="text-center" style="font-size: .875rem;"><b>CREAR UNA NUEVA CUENTA</b></v-col>
                <v-form ref="form_create_account">
                    <v-col>
                        <v-row>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field
                                    v-model="userNewAccount"
                                    label="Usuario"
                                    type="text"
                                    :rules=requiredRule
                                    prepend-inner-icon="mdi-account-outline"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field
                                    v-model="passwordNewAccount"
                                    label="Contraseña"
                                    type="password"
                                    :rules=requiredRule
                                    prepend-inner-icon="mdi-key-variant"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field
                                    v-model="firstNameNewAccount"
                                    label="Nombres"
                                    type="text"
                                    :rules=requiredRule
                                    prepend-inner-icon="mdi-account-outline"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field
                                    v-model="lastNameNewAccount"
                                    label="Apellidos"
                                    type="text"
                                    :rules=requiredRule
                                    prepend-inner-icon="mdi-account-outline"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="emailNewAccount"
                                    label="Correo (se enviará un correo para verificarlo)"
                                    type="email"
                                    :rules=emailRule
                                    prepend-inner-icon="mdi-email"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-col  class="text-center">
                            <v-btn 
                                color="primary" 
                                :loading=loadingBtn
                                class="px-5 text-center mx-2"
                                @click="createAccount"
                            >
                                <v-icon>mdi-account-plus</v-icon> CREAR CUENTA
                            </v-btn>
                            <v-btn class="mx-2" color="warning" 
                                @click="typeAccess='login'"
                            >
                                <v-icon>mdi-keyboard-backspace</v-icon> REGRESAR
                            </v-btn>
                        </v-col>
                    </v-col>
                </v-form>
                </v-card-text>
            </div>
            <div v-if="typeAccess=='restart-pass'" >
                <v-card-text class="py-0">
                <v-col cols="12" class="text-center" style="font-size: .875rem;"><b>REINICIA TU CONTRASEÑA CON TU USAURIO O IDENTIFICACIÓN</b></v-col>
                <v-form ref="form_reset_password">
                    <div v-if="typeof validUser != 'undefined'" :style="validUser ? 'color:green' :'color:red'" class="text-center">{{textValid}}</div>
                    <v-col>
                        <v-row>
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="userResetPass"
                                    label="Usuario o identificación"
                                    type="text"
                                    :rules=requiredRule
                                    prepend-inner-icon="mdi-account-circle"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-col  class="text-center">
                            <v-btn 
                                color="primary" 
                                :loading=loadingBtn
                                class="px-5 text-center mx-2"
                                @click="verifyUser"
                            >
                                <v-icon>mdi-account-plus</v-icon> VERIFICAR
                            </v-btn>
                            <v-btn class="mx-2" color="warning" 
                                @click="typeAccess='login'"
                            >
                                <v-icon>mdi-keyboard-backspace</v-icon> REGRESAR
                            </v-btn>
                        </v-col>
                    </v-col>
                </v-form>
                </v-card-text>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'LoginWebComponent',

    data:()=>({
        show:false,
        user:'',
        userResetPass:null,
        password:'',
        firstNameNewAccount:null,
        lastNameNewAccount:null,
        emailNewAccount:null,
        userNewAccount:null,
        passwordNewAccount:null,
        typeAccess:'login',
        textValid: '',
        validUser:undefined,
        requiredRule:[
            v => !!v || 'El campo es requerido'
        ],
        emailRule:[
            v => !!v || 'El correo es requerido',
            v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Escriba un correo válido'
        ]
    }),
    props:{

        dialogLogin:{
            type: Boolean,
            default: false
        },

        text:{
            type: String,
            default: 'INICIA SESIÓN PARA ACCEDER A DIVERSOS BENEFICIOS'
        }

    },
    computed:{
        ...mapState(['loadingBtn'])
    },
    methods: {

        ...mapActions(['loginAction','requestApi','alertNotification']),

        ...mapMutations(['setUrl','setLoadingBtn','setUserVerificated']),

        loginClient(){
            
            if(!this.$refs.form_login.validate())
                return

            this.setUrl('oauth')
    
            this.loginAction({
                user : this.user,
                password: this.password,
            }).then(res =>{

                this.$emit('close')
                
                console.log(res)

            })

        },

        createAccount(){

            if(!this.$refs.form_create_account.validate())
                return false

            this.setLoadingBtn()

            this.setUrl('user-login');
            this.requestApi({
                method: 'POST',
                data: {
                    firstName: this.firstNameNewAccount,
                    lastName: this.lastNameNewAccount,
                    email: this.emailNewAccount,
                    user: this.userNewAccount,
                    password: this.passwordNewAccount,
                }

            }).then(res=>{
                console.log(res)
                this.alertNotification({
                    param:{
                        html : res.data.msg
                    }
                })
                this.typeAccess= 'login'
                this.setLoadingBtn()
                this.setUserVerificated(false)
            })

        },

        verifyUser(){

            if(!this.$refs.form_reset_password.validate())
                return false

            this.setLoadingBtn()
            this.setUrl('user-login/1');
            this.requestApi({
                method: 'PATCH',
                data: {
                    userResetPass: this.userResetPass,
                }

            }).then(res=>{

                if(!res.data.verify){
                    this.textValid ='Usuario o identificación no está registrada, por favor cree una nueva cuenta'
                    this.validUser = false
                }else{
                    this.textValid ='Usuario validado, se ha enviado un enlace al siguiente correo para reiniciar su contraseña ' + res.data.billingEmail.info_string
                    this.validUser = true
                }
                console.log(res.data)
                this.setLoadingBtn()
                
            })

        }

    }
}

</script>